/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Sub_Upgrade_ConfirmInputs */



/**
* | output |
* | --- |
* | "Confirm {amount}" |
*
* @param {Sub_Upgrade_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_upgrade_confirm = /** @type {((inputs: Sub_Upgrade_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Upgrade_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bestätigen ${i?.amount}`)
	return /** @type {LocalizedString} */ (`Confirm ${i?.amount}`)
});